<template>
    <div class="base-input">
        <div class="base-input-label">
            {{label}}
        </div>
        <div class="base-input-box">
            <slot></slot>
        </div>
        <div class="base-input-messages">
            {{hint}}
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        label: String,
        hint: String,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    }
}
</script>

<style scoped>

* {
    --border-color: #aaa;
    --border-hover-color: #555;
}

.base-input {
    position: relative;
}

.base-input-label {
    position:absolute;
    top: -8px;
    left:0px;
    display:flex;
    font-size:12px;
    background-color: inherit;
    color: rgba(0,0,0,0.6);
    width:100%;
}

.base-input-label::before {
    flex-basis:8px;
    content: '';
    position:relative;
    top:8px;
    border-top:solid 1px var(--border-color);
    border-left:solid 1px var(--border-color);
    border-top-left-radius:5px;
    width:9px;
    height:10px;
    display:inline-block;
    margin-right:4px;
}
.base-input-label::after {
    flex-grow:1;
    content:'';
    position:relative;
    top:8px;
    border-top:solid 1px var(--border-color);
    border-right:solid 1px var(--border-color);
    border-top-right-radius:5px;
    height:10px;
    display:inline-block;
    margin-left:4px;
}

.base-input:hover .base-input-label::before {
    border-color: var(--border-hover-color);
}
.base-input:hover .base-input-label::after  {
    border-color: var(--border-hover-color);
}


.base-input-box {
    position:relative;
    min-height:40px;
    width: 100%;
    border: solid 1px var(--border-color);
    border-top: none;
    border-radius: 5px;
    background-color: transparent;
}

.base-input:hover .base-input-box {
    border-color: var(--border-hover-color);
}

.base-input-messages {
    height:14px;
    font-size:12px;
    margin-left:10px;
    margin-top:3px;
    color:#555;
    margin-bottom:5px
}

</style>




// WEBPACK FOOTER //
// BaseInput.vue?08c98b29